import { Col, Row } from 'reactstrap';
import dayjs from "dayjs";
import { LabeledFieldForPacCoverage } from 'components/common/standardComponents';

export default function PatientCoveragePlanDetails(props: any) {
    const planDetails = props.plan;
    const DATE_FORMAT = 'MM/DD/YYYY';
    return (
        <>
            <Row style={{ margin: '5px 0px' }}>
                <h5 style={{ paddingLeft: '0px', marginBottom: '0' }}>Plan Details</h5>
            </Row>
            <hr />
            <Row>
                <Col>
                    <LabeledFieldForPacCoverage
                        label='Plan Name'
                        value={planDetails.name}
                    />
                </Col>
            </Row>
            <hr />
            <Row>
                <Col>
                    <LabeledFieldForPacCoverage
                        label='Paln Type'
                        value={planDetails.planType}
                    />
                </Col>
                <Col>
                    <LabeledFieldForPacCoverage
                        label='Group Name'
                        value={planDetails.groupName}
                    />
                </Col>
                <Col>
                    <LabeledFieldForPacCoverage
                        label='Deductible'
                        value={planDetails.individualDeductible}
                    />
                </Col>
                <Col>
                    <LabeledFieldForPacCoverage
                        label='Deductible Remaining'
                        value={planDetails.individualDeductibleRemaining}
                    />
                </Col>
            </Row>
            <hr />
            <Row style={{marginBottom: '10px'}}>
                <Col>
                    <LabeledFieldForPacCoverage
                        label='OOP Max'
                        value={planDetails.outOfPocket}
                    />
                </Col>
                <Col>
                    <LabeledFieldForPacCoverage
                        label='OOP Remaining'
                        value={planDetails.outOfPocketRemaining}
                    />
                </Col>
                <Col>
                    <LabeledFieldForPacCoverage
                        label='Start Date'
                        value={planDetails.policyStart ? dayjs(planDetails.policyStart).format(DATE_FORMAT) : ''}
                    />
                </Col>
                <Col>
                    <LabeledFieldForPacCoverage
                        label='End Date'
                        value={planDetails.policyEnd ? dayjs(planDetails.policyEnd).format(DATE_FORMAT) : ''}
                    />
                </Col>
            </Row>
        </>
    );
}
